<template>
  <h1>案例展示</h1>
</template>

<script>
export default {

}
</script>

<style>
</style>